<template>
  <div class="row">
    <div class="col-12 col-lg-8 c g">
      <div class="card">
        <div class="card-header">
          <div>
            <h4 class="mb-25">
              <i class="fa fa-bell"></i>
              إشعار فوري لتطبيق ولي الأمر
            </h4>
            <span class="text-muted">يصل فوراً كإشعار على جوال ولي الأمر في تطبيق التحضير الذكي، ويظهر في قائمة الإشعارات داخل التطبيق. مجاني ولا يحتاج رصيد رسائل.</span>
          </div>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label for="push-title">عنوان الإشعار</label>
            <input id="push-title" class="form-control" v-model="title" maxlength="100" placeholder="مثال: اسم المدرسة">
          </div>
          <div class="form-group">
            <label for="push-body">نص الإشعار</label>
            <textarea id="push-body" class="form-control" rows="4" v-model="body" maxlength="1000" placeholder="اكتب الإشعار هنا..."></textarea>
            <small class="text-muted">{{ body.length }} / 1000</small>
          </div>

          <div class="d-flex justify-content-between align-items-center flex-wrap mb-50">
            <label class="mb-0">الفصول</label>
            <span>
              <a href="javascript:;" @click="selectAll(true)"><i class="fa fa-check-square"></i> اختيار الكل</a>
              &nbsp;·&nbsp;
              <a href="javascript:;" @click="selectAll(false)">إلغاء الكل</a>
            </span>
          </div>

          <div v-if="loading" class="text-center g">
            <img :src="require('@/assets/images/loading.svg')" style="width: 60px" alt="">
          </div>
          <p v-else-if="!classes.length" class="text-muted text-center g">لا يوجد طلاب في حسابك.</p>

          <div class="grades">
            <div class="grade" v-for="(g, gi) in grades" :key="g.name">
              <div class="grade-head">
                <label class="form-check-label grade-label" :for="'grade-' + gi">
                  <input type="checkbox" class="form-check-input position-static" :id="'grade-' + gi" :checked="gradeState(g) == 'all'" :indeterminate.prop="gradeState(g) == 'some'" @change="toggleGrade(g, $event.target.checked)">
                  <strong>{{ g.name }}</strong>
                </label>
              </div>
              <div class="rooms">
                <label v-for="(c, ci) in g.classes" :key="c.key" class="room" :class="{ on: selected.includes(c.key) }" :for="'room-' + gi + '-' + ci">
                  <input type="checkbox" class="form-check-input position-static" :id="'room-' + gi + '-' + ci" :value="c.key" v-model="selected">
                  <span>فصل {{ c.classroom }}</span>
                  <small class="text-muted num">{{ c.with_app }}/{{ c.students }}</small>
                </label>
              </div>
            </div>
          </div>
          <small class="text-muted d-block mt-50" v-if="classes.length">الرقم بجانب الفصل: عدد الطلاب المسجل أولياء أمورهم في التطبيق / عدد طلاب الفصل.</small>
        </div>

        <div class="card-footer">
          <div class="summary" v-if="selected.length">
            <div class="box ok">
              <strong class="num">{{ totals.with_app }}</strong>
              <span>طالب سيصل الإشعار لولي أمره</span>
            </div>
            <div class="box no">
              <strong class="num">{{ totals.students - totals.with_app }}</strong>
              <span>طالب ولي أمره لم يدخل التطبيق</span>
            </div>
          </div>
          <p class="text-muted small mb-1" v-if="selected.length && totals.students > totals.with_app">
            لإرسال رسالة SMS أو واتساب لمن لم يدخل التطبيق: من صفحة
            <router-link to="/students-messages">ارسال رسائل للطلاب</router-link>
            اختر «من لم يحمل التطبيق».
          </p>
          <button class="btn btn-primary btn-block btn-lg" @click="send()" :disabled="sending || !selected.length">
            <i class="fa fa-paper-plane"></i>
            {{ sending ? 'جاري الإرسال...' : (selected.length ? 'إرسال الإشعار الآن' : 'اختر الفصول أولاً') }}
          </button>
        </div>
      </div>

      <div class="card" v-if="history.length">
        <div class="card-header">
          <h5 class="mb-0"><i class="fa fa-history"></i> الإشعارات المرسلة</h5>
        </div>
        <div class="card-body table-responsive">
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>التاريخ</th>
                <th>الإشعار</th>
                <th>الفصول</th>
                <th>وصل إلى</th>
                <th>بواسطة</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="h in history" :key="h._id">
                <td class="num nowrap">{{ h.date }}</td>
                <td>
                  <strong>{{ h.title }}</strong>
                  <small class="d-block text-muted pre">{{ h.body }}</small>
                </td>
                <td>
                  <small :title="h.classrooms.join('، ')">{{ h.classrooms.length }} فصل</small>
                </td>
                <td class="num nowrap">{{ h.with_app }} من {{ h.students }} طالب</td>
                <td><small>{{ h.admin_name }}</small></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      loading: true,
      sending: false,
      classes: [],
      selected: [],
      title: '',
      body: '',
      history: [],
    };
  },
  computed: {
    // Classes grouped by grade, in the server's order.
    grades() {
      var out = [];
      this.classes.forEach(function(c){
        var g = out.find(function(x){ return x.name == c.classname; });
        if(!g) out.push(g = { name: c.classname, classes: [] });
        g.classes.push(c);
      });
      return out;
    },
    totals() {
      var g = this;
      return this.classes.filter(function(c){ return g.selected.includes(c.key); }).reduce(function(t, c){
        return { students: t.students + c.students, with_app: t.with_app + c.with_app };
      }, { students: 0, with_app: 0 });
    },
  },
  created() {
    if(!checkPer("students|students|send")){
      this.$router.push('/NotPermitted');
      return false;
    }
    this.loadClasses();
    this.loadHistory();
  },
  methods: {
    loadClasses() {
      var g = this;
      $.post(api + '/user/push/classes', { jwt: this.user.jwt }).then(function(r){
        g.loading = false;
        if(r.status != 100) return alert(r.response, 200);
        g.classes = r.response;
        if(!g.title) g.title = r.school_name || '';
      }).fail(function(){
        g.loading = false;
      });
    },
    loadHistory() {
      var g = this;
      $.post(api + '/user/push/history', { jwt: this.user.jwt }).then(function(r){
        if(r.status == 100) g.history = r.response;
      });
    },
    gradeState(grade) {
      var n = grade.classes.filter((c) => this.selected.includes(c.key)).length;
      return n == 0 ? 'none' : n == grade.classes.length ? 'all' : 'some';
    },
    toggleGrade(grade, on) {
      var keys = grade.classes.map(function(c){ return c.key; });
      this.selected = this.selected.filter(function(k){ return !keys.includes(k); });
      if(on) this.selected = this.selected.concat(keys);
    },
    selectAll(on) {
      this.selected = on ? this.classes.map(function(c){ return c.key; }) : [];
    },
    send() {
      if(!this.title.trim() || !this.body.trim()) return alert('اكتب عنوان الإشعار ونصه.', 200);
      if(!this.totals.with_app) return alert('لا يوجد أولياء أمور مسجلين في التطبيق في الفصول المختارة.', 200);
      if(!confirm('سيصل الإشعار الآن لأولياء أمور ' + this.totals.with_app + ' طالب في ' + this.selected.length + ' فصل. متابعة؟')) return;
      var g = this;
      g.sending = true;
      $.post(api + '/user/push/send', {
        jwt: this.user.jwt,
        classrooms: this.selected,
        title: this.title,
        body: this.body,
      }).then(function(r){
        g.sending = false;
        if(r.status != 100) return alert(r.response, 200);
        alert('تم إرسال الإشعار لأولياء أمور ' + r.response.with_app + ' طالب.', 100);
        g.body = '';
        g.selected = [];
        g.loadHistory();
      }).fail(function(){
        g.sending = false;
        alert('تعذر الاتصال بالسيرفر، حاول مرة أخرى.', 200);
      });
    },
  },
};
</script>

<style scoped>
.grades {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.grade {
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 10px;
  padding: 10px 12px;
}
.grade-head {
  margin-bottom: 8px;
}
.grade-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.rooms {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 6px;
}
.room {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 6px 8px;
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 8px;
  cursor: pointer;
}
.room.on {
  border-color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
}
.room small {
  margin-right: auto;
}
.num {
  font-variant-numeric: tabular-nums;
}
.nowrap {
  white-space: nowrap;
}
.pre {
  white-space: pre-line;
}
.summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}
.summary .box {
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
}
.summary .box strong {
  font-size: 1.6rem;
  line-height: 1.2;
}
.summary .ok {
  background: var(--sk-oks, #DCFAE6);
  color: var(--sk-oki, #067647);
}
.summary .no {
  background: var(--sk-was, #FEF0C7);
  color: var(--sk-wai, #B54708);
}
</style>
